<div class="upsell-section">
  <div class="upsell-section__container flex justify-center">
    <div class="upsell-section__wrapper px-4 w-full">
      <ng-template ngFor let-item [ngForOf]="content" let-i="index">
        <div *ngIf="item.title && item.title.length > 0" class="text-center md:text-left mb-4 uppercase" [innerHTML]="item.title"></div>
        <ng-template ngFor let-block [ngForOf]="item.blocks" let-i="index">
          <div class="mb-4" [ngClass]="'upsell-section-inner-div-' + (i + 1)" [innerHTML]="block" ></div>
        </ng-template>
      </ng-template>
    </div>
  </div>
</div>